"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSignatures = void 0;
const axios_1 = __importDefault(require("axios"));
const errors_1 = require("../errors");
const utils_1 = require("../utils");
const GASLESS_WALLET_BACKEND = "https://gasless-wallet-api.prod.gelato.digital";
const getSignatures = (domains) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return (yield axios_1.default.post(`${GASLESS_WALLET_BACKEND}/whitelist`, { domains })).data;
    }
    catch (error) {
        throw new errors_1.GaslessOnboardingError(errors_1.ErrorTypes.ServerError, (0, utils_1.getHttpErrorMessage)(error));
    }
});
exports.getSignatures = getSignatures;
